<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
        <v-toolbar flat class="toolbar" dense align="center" justify="center">
                <v-toolbar-title>Parent Info</v-toolbar-title>
                <v-divider class="mx-4" color="white" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>    
        <v-row justify="center" dense v-if="ay_std_div_list != null">
            <v-col sm="2">
                <v-icon color="error">*</v-icon>
                <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                    :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd()"
                    persistent-hint hint="Please Select Academic Year" />
            </v-col>
            <v-col sm="2" v-if="std_div_list != null">
                <v-icon color="error">*</v-icon>
                <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                    :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" persistent-hint
                    hint="Please Select Standard" />
            </v-col>
            <v-col sm="2" v-if="div_list != null">
                <v-icon color="error">*</v-icon>
                <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                    item-text="div_name" label="Division" outlined persistent-hint hint="Please Select Division" />
            </v-col>
            <v-col sm="2" v-if="div != null" class="mt-7 ml-5">
                <!-- <br /> -->
                <v-btn :loading="btn_get_loading" @click="getLParentData" color="primary">Get Info</v-btn>
            </v-col>
        </v-row>
        </v-card>
        
        <v-card class="box" v-if="lp_data != null">
            <v-toolbar flat class="toolbar" dense align="center" justify="center">
                <v-toolbar-title>Student Parent List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" background-color="white" append-icon="search" label="Search" single-line
                        hide-details></v-text-field>
                <v-btn v-if="lp_data!=null " class="ml-5" small rounded color="white" outlined @click="fnExcelReport('my-table-id', 'ParentInfo')"
                :loading="loader"><v-icon color="white">mdi-export</v-icon>Export</v-btn>
            </v-toolbar>
            <v-col cols="12" md="12" sm="12">
                <div id="my-table-id">
                    <v-data-table :items="lp_data" :headers="headers" dense class="elevation-1 mytable" :search="search"
                        :items-per-page="-1">
                        <template v-slot:item.action="{ item }">
                            <v-btn color="secondary" icon dark @click="addEdit(item)">
                                <v-icon v-if="item.pid == null">mdi-plus-circle</v-icon>
                                <v-icon v-else>mdi-pencil-circle-outline</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </div>
            </v-col>
        </v-card>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title class="toolbar"> Edit </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Personal Email" v-model.trim="editedItem.personal_email"
                                :rules="[rules.email]" placeholder="Eg: vchauhan@eduplusnow.com"
                                persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="Primary No" v-model="editedItem.mobile_no"
                                placeholder="Eg: 976XXXXXXX"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="Father Mobile No" v-model.trim="editedItem.father_contact_no"
                                placeholder="Eg: 976XXXXXXX"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="Mother Mobile No" v-model.trim="editedItem.mother_contact_no"
                                placeholder="Eg: 976XXXXXXX"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="Father email" :rules="[rules.email]" v-model="editedItem.father_email"
                                placeholder="Eg: vchauhan@eduplusnow.com"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="Mother email" :rules="[rules.email]" v-model="editedItem.mother_email"
                                placeholder="Eg: vchauhan@eduplusnow.com"></v-text-field>
                        </v-col>
                        <v-divider></v-divider>

                        <v-row>
                            <v-col cols="12" style="text-align: right;">
                                <v-btn color="primary" text :loading="save_edit_load" @click="saveAddEdit(editedIndex)">
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>
                                <v-btn color="primary" text @click="dialog = false">
                                    <v-icon>mdi-close-box</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            rules: {
                required: (value) => !!value || "Required.",
                counter: (value) => value.length <= 20 || "Max 20 characters",
                email: (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            },
            //
            snackbar_msg: "",
            snackbar: false,
            color: "",
            btn_get_loading: false,
            //
            div: null,
            // extraBreadcrumbItems: [
                

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            ay_std_div_list: null,
            sel_ay_data: null,
            show_tt: false,
            std_div_list: null,
            sel_std_data: null,
            //
            dialog: false,
            save_edit_load: false,
            //
            lp_data: null,
            loader: false,
            search: "",

            table_fields: {
                "Sr. No": "srno",
                "Student Name": "lname",
                "PRN. No.": "grno",
                Standard: "std",
                Division: "div",
                "Parent Login-Id": "ploginid",
                "Student Login-Id": "lLoginid",
                "Personal email": "personal_email",
                "Primary Mob.": "mobile_no",
                "Father Mob": "father_contact_no",
                "Mother Mob": "mother_contact_no",
                "Father email": "father_email",
                "Mother email": "mother_email",
            },

            headers: [
                { text: "Sr. No.", value: "srno", sortable: true },
                { text: "Student", value: "lname", sortable: true },
                { text: "PRN No", value: "grno", sortable: true },
                { text: "Standard", value: "std", sortable: true },
                { text: "Division", value: "div", sortable: true },
                { text: "Parent Login-Id", value: "ploginid", sortable: true },
                { text: "Secondary Parent Login-Id", value: "sploginid", sortable: true },
                { text: "Student Login-Id", value: "lLoginid", sortable: true },
                { text: "Personal email", value: "personal_email", sortable: true },
                { text: "Primary Mob.", value: "mobile_no", sortable: true },
                { text: "Father Mob", value: "father_contact_no", sortable: true },
                { text: "Mother Mob", value: "mother_contact_no", sortable: true },
                { text: "Father email", value: "father_email", sortable: true },
                { text: "Mother email", value: "mother_email", sortable: true },

                { text: "Action", value: "action", sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                srno: null,
                lid: null,
                grno: null,
                lname: null,
                std: null,
                div: null,
                pid: null,
                pname: null,
                pemail: null,
                pmobile: null,
                ploginid: null,
                lLoginid: null,
            },
        }),
        methods: {
              fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
    
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            addEdit(item) {
                this.editedIndex = this.lp_data.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            saveAddEdit() {
                this.save_edit_load = true;
                axios
                    .post("/roleManagement/saveAddEditParent", this.editedItem)
                    .then((res) => {
                        console.log(res.data.status);
                        if (res.data.status == "YES") {
                            Object.assign(this.lp_data[this.editedIndex], this.editedItem);
                            this.showSnackbar("#4CAF50", res.data.status_reason);
                        } else if (res.data.status == "REFRESH") {
                            //REFRESH
                            console.log("refresh");
                            this.lp_data = null;
                            this.getLParentData();
                            this.showSnackbar("#4CAF50", res.data.status_reason);
                            console.log(this.lp_data);
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.save_edit_load = false;
                        this.dialog = false;
                    });
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = null;
                this.div = null;
                this.div_list = this.sel_std_data.div_list;

                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                } else {
                    this.div_list.splice(0, 0, "All");
                }
            },

            getLParentData() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    std: this.sel_std_data.std_id,
                    div: this.div,
                };
                console.log("in getLParentData", data);
                this.btn_get_loading = true;
                axios
                    .post("/roleManagement/parentInfo", data)
                    .then((res) => {
                        this.lp_data = res.data.lp_data;
                        //this.showSnackbar("#4CAF50","Success")
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.btn_get_loading = false;
                    });
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        console.log(res.data);
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.sel_ay_data;
                        // this.std_div_list;
                        // this.sel_std_data = null;
                        // this.div_list = null;
                        // this.div = null;
                        for (let index = 0; index < this.ay_std_div_list.length; index++) {
                            this.std_div_list = this.ay_std_div_list[index].std_list;
                            this.div_list = this.ay_std_div_list[index].std_list.div_list;
                        }

                        // this.std_div_list = res.data.std_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },

        mounted() {
            this.onload();
            // this.loader = true;
            // this.getLParentData();
        },
    };
</script>
